import { FileUploader } from 'react-drag-drop-files'
import { GetImages } from '../../../utils/GetImages'
import { DocumentService } from '@propertelligent/client-api';
import apiHelper from '../../../utils/apiHelper';
import { useError } from '../../../utils/context/ErrorContext';

const DragAndDropUploader = ({ handleChange, docsArr, setDocsArr, name }) => {
  const { errors, errorMessages } = useError();
  const handleDelete = (id, index) => {
    if (id) {
      apiHelper(DocumentService.deleteApiDocument, { showNotification: false }, id)
        .then((res) => {
          if (res?.data?.success) {
            const updatedDocsArr = docsArr.filter((doc) => doc.id !== id);
            setDocsArr(updatedDocsArr)
          }
        })
    } else {
      const updatedDocsArr = docsArr.filter((_, idx) => idx !== index);
      setDocsArr(updatedDocsArr)
    }
  };

  return (
    <>
      <div className="dragAndDropUploader_main ">
        <p className="normal_text"> {name} <span className='red'>*</span></p>
        <FileUploader
          handleChange={handleChange}
          classes="fileuploaderbutton clickable"
          children={
            <>
              <div className="dragAndDropUploader">
                <img width={24} height={24} src={GetImages.upload} />
                <div>
                  <p className='normal_text fw-600'> Drag & Drop or <span className="blue"> Browse </span></p>
                  <p className='normal_text'> .pdf, .png, .jpeg; Max file size: 1mb</p>
                </div>
              </div>
            </>
          }
        />
        {docsArr.length > 0 && (
          <div
            className="fileDeleteSection">
            {docsArr.map((doc, index) => (
              <div
                key={index}
                className="documentContainerEditForm"
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <img width={20} height={24} src={GetImages.pdfImage} />
                  <p
                    className="licenseDocumentText"
                    title={doc?.fileName}>
                    {doc?.fileName}
                  </p>
                </div>
                <img
                  width={20}
                  height={20}
                  onClick={() => handleDelete(doc?.id, index)}
                  src={GetImages.deleteIconRed}
                  style={{ cursor: "pointer" }}
                />
              </div>
            ))}
          </div>
        )}

        {(errors.FileType || errors.FileSize) && (
          <div style={{ marginTop: "8px" }}>
            {errors.FileType && (
              <p className="errorMessageStyles">{errorMessages.FileType}</p>
            )}
            {errors.FileSize && (
              <p className="errorMessageStyles">{errorMessages.FileSize}</p>
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default DragAndDropUploader